import React, { useEffect, useState } from "react";
import { Col, Container, Image, Row, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import job_logo from "../assets/images/job_logo.png";
import forCompLoc from "../assets/images/forCompLoc.png";
import innerJobs0 from "../assets/images/innerJobs0.png";
import innerJobs1 from "../assets/images/innerJobs1.png";
import innerJobs2 from "../assets/images/innerJobs2.png";
import innerJobs3 from "../assets/images/innerJobs3.png";
import innerJobs4 from "../assets/images/innerJobs4.png";
import innerJobs5 from "../assets/images/innerJobs5.png";
import experienceImg from "../assets/images/experience.png";
import timeDuration from "../assets/images/timeDuration.png";
import JobCardOne from "../Components/JobCardOne";
import ShareIcon from "@mui/icons-material/Share";
import { useLocation } from "react-router-dom";
import { imageUrl, URL, apiHeader } from "../Config/apiUrl";
import { useSelector } from "react-redux";
import JobsCard from "../Components/JobsCard";
import { toast } from "react-toastify";

import { Get, Post } from "../Axios/AxiosFunctions";
import moment from "moment";
import ShareToolTip from "../Components/ShareToolTip";
import AppliedCraftmanModal from "../Components/AppliedCraftmanModal";
import { Avatar } from "@mui/material";
import BodyLoader from "../Components/BodyLoader";
import ReportJobModal from "../Components/ReportJobModal";
import JobApplyModal from "../Components/JobApplyModal";

const JobDetailScreen = ({ setfooterStyle }) => {
  const history = useHistory();
  const location = useLocation();
  const jobId = location.state;
  const token = useSelector((state) => state?.authReducer?.access_token);
  const role = useSelector((state) => state?.authReducer?.user?.UserId?.role);
  const user = useSelector((state) => state?.authReducer?.user);
  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  // ------------------------------- states ------------------------------------
  const [jobData, setJobData] = useState(null);
  const [similarJobs, setSimilarJobs] = useState([]);
  const [isApiCall, setIsApiCall] = useState(false);
  const [isApplyingOnJob, setIsApplyingOnJob] = useState(false);
  const [showToolTip, setShowToolTip] = useState(false);
  const [isFollowingCompany, setIsFollowingCompany] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [craftmansData, setCraftmansData] = useState([]);
  const [appliedJobData, setAppliedJobData] = useState();
  const [appliedCraftmansIds, setAppliedCraftmansIds] = useState([]);
  const [reportStatements, setReportStatements] = useState([]);

  const [isJobApplyModalOpen, setIsJobApplyModalOpen] = useState(false);
  // ------------------------------ handlers ----------------------------------------
  const getData = async () => {
    let url = URL(`job/getspecificjob?id=${jobId}`);
    // for guest
    if (!jobId) {
      let jobIdfromWindow = window.location.pathname.split("/job/")[1];
      if (!jobIdfromWindow) {
        toast.error("Something went wrong.");
        return history.push("/dashboard");
      }
      url = URL(`job/getspecificjob?id=${jobIdfromWindow}`);
    }

    setIsApiCall(true);
    const response = await Get(url, token, false);
    setIsApiCall(false);

    if (response !== undefined) {
      setJobData(response?.data?.data?.jobDetail);
      setSimilarJobs([
        ...response?.data?.data?.similarJobs,
        ...response?.data?.data?.similarJobs,
      ]);
      // setSimilarJobs(response?.data?.data?.similarJobs);
      setCraftmansData(response?.data?.data?.jobDetail?.appliedCraftmans);
      setAppliedCraftmansIds(
        response?.data?.data?.jobDetail?.appliedCraftmans?.map(
          (item) => item._id
        )
      );
    } else {
      toast.error("Something went wrong.");
      return history.push("/dashboard");
    }
  };

  // run side effects
  useEffect(() => {
    getData();
    giveJobAView();
    role == "user" && getReportStatements();
  }, []);

  // jobApplyHandler
  const jobApplyHandler = async (motivationalLetter, comment) => {
    if (!token) {
      return history.push("/signin");
    }

    const url = URL("job/jobApply");

    const formData = new FormData();
    formData.append("jobId", jobId);
    formData.append("crafmanId", user?._id);
    formData.append("motivationalLetter", motivationalLetter);
    formData.append("comment", comment);

    setIsApplyingOnJob(true);
    const response = await Post(url, formData, apiHeader(token, true));
    setIsApplyingOnJob(false);

    if (response !== undefined) {
      setIsJobApplyModalOpen(false);
      toast.success("You have successfully applied on this job.");
      const jobDataCopy = { ...jobData };
      setAppliedCraftmansIds((p) => [...p, user?._id]);
      setJobData(jobDataCopy);
    } else {
      formData.delete("jobId");
      formData.delete("crafmanId");
      formData.delete("motivationalLetter");
      formData.delete("comment");
    }
  };

  // handleCompanyFollow
  const handleCompanyFollow = async () => {
    const isCurrentFollower = jobData?.companyId?.followers?.includes(
      user?._id
    );
    if (isFollowingCompany) {
      return;
    }

    const params = {
      id_craftman: user?._id,
      id_company: jobData?.companyId?._id,
      follow: isCurrentFollower ? false : true,
    };

    const url = URL("craftman/follow-or-unfollow-company");
    setIsFollowingCompany(true);
    const response = await Post(url, params, apiHeader(token));
    setIsFollowingCompany(false);

    if (response !== undefined) {
      toast.success(
        `${jobData?.companyId?.companyName} ${
          !isCurrentFollower ? "followed" : "unfollowed"
        } successfully.`
      );

      const jobDataCopy = { ...jobData };
      if (isCurrentFollower) {
        jobDataCopy.companyId.followers = jobData?.companyId?.followers?.filter(
          (e) => e != user?._id
        );
      } else {
        jobData?.companyId?.followers.push(user?._id);
      }

      setJobData(jobDataCopy);
    }
  };

  // giveJobAView
  const giveJobAView = async () => {
    if (role !== "user") {
      return;
    }
    const url = URL(`job/job-view/${jobId}`);
    await Post(url, {}, apiHeader(token), false);
  };

  // get report statements
  const getReportStatements = async () => {
    const url = URL("general/job-selection-radio");
    const response = await Get(url);

    if (response !== undefined) {
      setReportStatements(response.data.data);
    }
  };

  const [isReporting, setIsReporting] = useState(false);
  const [isReportJobModalOpen, setIsReportJobModalOpen] = useState(false);

  // handleReport
  const handleReport = async (id) => {
    if (!id) {
      return toast.error("Please select an option to continue.");
    }

    const url = URL("job/report-job");
    const params = {
      job: jobId,
      report: id,
    };

    setIsReporting(true);
    const response = await Post(url, params, apiHeader(token));
    setIsReporting(false);

    if (response !== undefined) {
      toast.success("Your report has been sent successfully.");
      const jobDataCopy = { ...jobData };
      jobDataCopy.reports.push(response.data.data);
      setJobData(jobDataCopy);
      setIsReportJobModalOpen(false);
    }
  };

  // to scroll top up when page refreshed
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  if (isApiCall) {
    return <BodyLoader />;
  }

  return (
    <div>
      <Container className="min_width" style={{ marginTop: "80px" }}>
        <Row>
          <Col className="first_box_jobTitle">
            <div>
              <div className="first_col_jobTitle">
                <div className="first_col_innner">
                  <div>
                    <Image
                      src={`${imageUrl}${jobData?.companyId?.photo}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = job_logo;
                      }}
                      className="company-detail-photo"
                    />
                  </div>
                  <div className="margin-left-30">
                    <h4 className="job_title_head">{jobData?.title}</h4>
                    <p className="big_p" style={{ color: "#000" }}>
                      {jobData?.companyId?.companyName}
                    </p>
                    <div className="mt-2">
                      <Image src={innerJobs0} className="mr-2" />
                      {jobData?.address}
                    </div>
                  </div>
                </div>
                <div>
                  <Row>
                    <Col className="d-flex inner_2nd_column mt-4">
                      <div className="test_div">
                        <div>
                          <Image className="jobDetail-icon" src={innerJobs1} />
                          <p className="big_p black">
                            Posted {moment(jobData?.createdAt).fromNow()}
                          </p>
                        </div>
                        {/* Views */}
                        <div>
                          <Image className="jobDetail-icon" src={innerJobs2} />
                          <p className="big_p black">
                            {jobData?.views ? jobData?.views.length : 0} Views
                          </p>
                        </div>

                        {/* Report */}
                        {role == "user" && (
                          <div
                            className="c-p"
                            onClick={() => {
                              let isAlreadyReported = jobData?.reports.some(
                                (e) => e?.user == user?._id
                              );

                              if (isAlreadyReported) return;
                              setIsReportJobModalOpen(true);
                            }}
                          >
                            <Image
                              className="jobDetail-icon"
                              src={innerJobs3}
                            />
                            <p className="big_p black">
                              {jobData?.reports.some(
                                (e) => e?.user == user?._id
                              )
                                ? "You Reported this Job"
                                : "Report Job"}
                            </p>
                          </div>
                        )}
                        {/* Salary */}
                        <div>
                          <Image className="jobDetail-icon" src={innerJobs4} />
                          <p className="big_p black">{`USD ${parseFloat(
                            jobData?.min
                          ).toFixed(2)} - ${parseFloat(jobData?.min).toFixed(
                            2
                          )}/Month`}</p>
                        </div>
                        {/* Experience */}
                        <div>
                          <Image
                            className="jobDetail-icon"
                            src={experienceImg}
                          />
                          <p className="big_p black">
                            Experience: {jobData?.experience}
                          </p>
                        </div>
                        {/* Time */}
                        <div>
                          <Image className="jobDetail-icon" src={innerJobs5} />
                          <p className="big_p black">
                            {jobData?.jobDuration == "Fixed"
                              ? "Full Time"
                              : jobData?.jobDuration}
                          </p>
                        </div>
                        {/* timeDuration  */}
                        {jobData?.jobDuration == "Time Limited" && (
                          <div>
                            <Image
                              className="jobDetail-icon"
                              src={timeDuration}
                            />
                            <p className="big_p black">
                              Time Duration:{" "}
                              {moment(jobData?.timeDuration1).format(
                                "MMM Do YYYY"
                              )}{" "}
                              -{" "}
                              {moment(jobData?.timeDuration2).format(
                                "MMM Do YYYY"
                              )}
                            </p>
                          </div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>

                <Row className="mt-3">
                  <Col className="d-flex  j-between a-center">
                    <div>
                      {role != "company" && (
                        <>
                          <Button
                            style={{ marginRight: "10px" }}
                            // onClick={jobApplyHandler}
                            onClick={() => setIsJobApplyModalOpen(true)}
                            disabled={
                              isApplyingOnJob ||
                              appliedCraftmansIds.includes(user?._id)
                            }
                          >
                            {appliedCraftmansIds.includes(user?._id)
                              ? "You have applied on this job"
                              : isApplyingOnJob
                              ? "Please Wait..."
                              : "Apply"}
                          </Button>
                        </>
                      )}
                    </div>
                    <div className="d-flex color_share ">
                      <ShareIcon />
                      <span
                        className="font-20"
                        onClick={() => setShowToolTip((p) => !p)}
                      >
                        Share this job
                      </span>
                      {showToolTip && (
                        <ShareToolTip
                          url={window.location.href}
                          title={jobData?.title}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <Container className="min_width second_box_jobTitle">
        <Row>
          <Col>
            <h4 className="cus_h4 mb-3">Job Description</h4>

            <p style={{ whiteSpace: "pre-line" }}>{jobData?.description}</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <h4 className="cus_h4 mb-3">Skills</h4>
          </Col>
        </Row>
        <Row>
          <Col className="skills_tag d-flex">
            {jobData?.skillsRequired?.map((e) => (
              <h6>{e}</h6>
            ))}
          </Col>
        </Row>
        <Row>
          <Col>
            <h4 className="cus_h4 mb-3 mt-4">Job Details</h4>
            {/* job type */}
            <div className="job_details_main">
              <div className="details_heading">
                <h6>Job Type:</h6>
              </div>
              <div>
                <h6 className="details_text">{jobData?.jobType}</h6>
              </div>
            </div>
            {/* job type */}
            <div className="job_details_main">
              <div className="details_heading">
                <h6>Salary:</h6>
              </div>
              <div>
                <h6 className="details_text">
                  ${parseFloat(jobData?.min).toFixed(2)} - $
                  {parseFloat(jobData?.max).toFixed(2)}
                </h6>
              </div>
            </div>
            {/* No of Hours per Week */}
            <div className="job_details_main">
              <div className="details_heading">
                <h6>No of Hours per Week:</h6>
              </div>
              <div>
                <h6 className="details_text">{jobData?.workingHours} Hours</h6>
              </div>
            </div>
            {/* Certification Required */}
            <div className="job_details_main">
              <div className="details_heading">
                <h6>Certification Required:</h6>
              </div>
              <div>
                <h6 className="details_text">
                  {jobData?.certificatesRequired?.join(", ")}
                </h6>
              </div>
            </div>
            {/* Form of Employment: */}
            <div className="job_details_main">
              <div className="details_heading">
                <h6>Form of Employment:</h6>
              </div>
              <div>
                <h6 className="details_text">{jobData?.jobType}</h6>
              </div>
            </div>
            {/* {arrayDetails.map((item, i) => {
              return (
                <div className="job_details_main" key={i}>
                  <div className="details_heading">
                    <h6>{item.heading}</h6>
                  </div>

                  <div>
                    <h6 className="details_text">{item.details}</h6>
                  </div>
                </div>
              );
            })} */}
          </Col>
        </Row>
        <Row>
          <Col className="text-center mt-5">
            <div>
              {role != "company" && (
                <>
                  {/* <Button
                    onClick={jobApplyHandler}
                    disabled={
                      isApplyingOnJob ||
                      appliedCraftmansIds?.includes(user?._id)
                    }
                  >
                    {appliedCraftmansIds?.includes(user?._id)
                      ? "You have applied on this job"
                      : isApplyingOnJob
                      ? "Please Wait..."
                      : "Apply"}
                  </Button> */}
                </>
              )}
            </div>
          </Col>
        </Row>
      </Container>

      <Container className="min_width third_box_jobTitle">
        <Row>
          <Col>
            <div className="company-follow-container">
              <div className="d-flex  a-center">
                <Image
                  style={{
                    width: "7rem",
                    "border-radius": "20%",
                  }}
                  src={`${imageUrl}${jobData?.companyId?.photo}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = job_logo;
                  }}
                />
                <div className="ml-30">
                  <h4 className="custom_30">
                    {jobData?.companyId?.companyName}
                  </h4>
                  <h6 className="cus_profile_des">
                    {`Contact Person: ${jobData?.companyId?.contactPerson}`}
                  </h6>
                  <h6 className="cus_profile_des">
                    Contact No: ({jobData?.companyId?.countryCode}){" "}
                    {jobData?.companyId?.contactNo}
                  </h6>
                </div>
              </div>

              {user?.UserId?.role === "user" && (
                <h6
                  onClick={handleCompanyFollow}
                  className="follow-company-btn"
                  title={
                    jobData?.companyId?.followers?.includes(user?._id)
                      ? "Click to Unfollow"
                      : "Click to Follow"
                  }
                >
                  {isFollowingCompany
                    ? "Please Wait"
                    : jobData?.companyId?.followers?.includes(user?._id)
                    ? "Following"
                    : "Follow"}
                </h6>
              )}
            </div>
          </Col>
        </Row>
      </Container>
      {/* Applied CraftMans */}
      {role === "company" &&
        user?._id == jobData?.companyId?._id &&
        jobData?.status !== "completed" && (
          <Container className="min_width third_box_jobTitle">
            <div className="">
              <h4 className="mb-3">Applied Craftmans</h4>
              {craftmansData?.length == 0 && <p>No Craftman Applied yet.</p>}
              <Row>
                {craftmansData?.map((item) => {
                  return (
                    <Col lg={6}>
                      <div className="applied-craftman-card">
                        <Row>
                          <Col lg={9}>
                            <div className="d-flex a-center">
                              <Avatar
                                src={`${imageUrl}${item?.photo}`}
                                sx={{ width: 70, height: 70 }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = innerJobs2;
                                }}
                              />
                              <h6 className="ms-4">{item?.userName}</h6>
                            </div>
                          </Col>
                          <Col lg={3} className="d-flex a-center">
                            <a
                              onClick={(e) => {
                                e.preventDefault();
                                setAppliedJobData(item);
                                setIsOpen(true);
                              }}
                            >
                              View Details
                            </a>
                          </Col>
                          <Col lg={12}>
                            <ul>
                              <li>
                                <span>Eduction:</span>
                                {item?.education}
                              </li>
                              <li>
                                <span>Experience:</span>
                                {item?.experience}
                              </li>
                            </ul>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            </div>
          </Container>
        )}

      {/* Hired craftman */}
      {role === "company" &&
        user?._id == jobData?.companyId?._id &&
        jobData?.status === "completed" && (
          <Container className="min_width third_box_jobTitle">
            <div className="">
              <h4 className="mb-3">Hired Craftman</h4>
              <Row>
                <Col lg={6}>
                  <div className="applied-craftman-card">
                    <Row>
                      <Col lg={9}>
                        <div className="d-flex a-center">
                          <Avatar
                            src={`${imageUrl}${jobData?.hired?.photo}`}
                            sx={{ width: 70, height: 70 }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = innerJobs2;
                            }}
                          />
                          <h6 className="ms-4">{jobData?.hired?.userName}</h6>
                        </div>
                      </Col>
                      <Col lg={3} className="d-flex a-center">
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            history.push(
                              "/ctaftman-profile?id=" + jobData?.hired?._id
                            );
                          }}
                        >
                          View Profile
                        </a>
                      </Col>
                      <Col lg={12}>
                        <ul>
                          <li>
                            <span>Eduction:</span>
                            {jobData?.hired?.education}
                          </li>
                          <li>
                            <span>Experience:</span>
                            {jobData?.hired?.experience}
                          </li>
                        </ul>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        )}

      {/* Similar Job Titles only for user */}
      {user?.UserId?.role == "user" && (
        <Container className="min_width">
          <Row>
            <Col>
              <h4 className="f-40 mt-5">Similar Job Titles</h4>
            </Col>
          </Row>
          <Row>
            {similarJobs.length > 0 ? (
              similarJobs.map((e) => <JobsCard data={e} />)
            ) : (
              <p>No Similar Job Found.</p>
            )}
          </Row>
        </Container>
      )}
      <AppliedCraftmanModal
        open={isOpen}
        setOpen={setIsOpen}
        data={appliedJobData}
        jobId={jobData?._id}
        comment={jobData?.comment}
        motivationalLetter={jobData?.motivationalLetter}
        title={jobData?.title}
        companyName={jobData?.companyId?.companyName}
      />

      {isReportJobModalOpen && (
        <ReportJobModal
          open={isReportJobModalOpen}
          setOpen={setIsReportJobModalOpen}
          isLoading={isReporting}
          data={reportStatements}
          onSubmit={handleReport}
        />
      )}
      {isJobApplyModalOpen && (
        <JobApplyModal
          open={isJobApplyModalOpen}
          setOpen={setIsJobApplyModalOpen}
          isLoading={isApplyingOnJob}
          onSubmit={jobApplyHandler}
        />
      )}
    </div>
  );
};

export default JobDetailScreen;
